import React from "react";
import classNames from "classnames";
import * as moment from "moment";

import { NavLink } from "react-router-dom";

import { getImageURL } from "../../utils/functions";

const BlogItems = ({
  blogPosts,
  assets,
  tableDataTotal,
  currentPage,
  paginationList,
  paginateTable
}) => (
  <main className="col-lg-12">
    <div className="blog-items">
      {blogPosts.map(({ fields, sys }, index) => {
        const { title, description, publishDate, heroImage } = fields;

        return (
          <article
            key={`blog-${index}`}
            className="vertical-item box-shadow"
          >
            <div className="item-media">
              <img src={getImageURL(assets, heroImage.sys.id)} alt="img" />
            </div>
            <div className="item-content">
              <p className="mb-0 item-meta d-flex justify-content-xl-start flex-xl-row flex-column justify-content-center flex-wrap">
                <span>
                  <NavLink to={`resources/article/${sys.id}`}>
                    <a rel="bookmark">
                      <time
                        className="published entry-date"
                        datetime={publishDate}
                      >
                        {moment(publishDate).format("DD MMMM YY")}
                      </time>
                    </a>
                  </NavLink>
                </span>
              </p>

              <h5 className="letter-sp-normal font-weight-regular mt-10 mb-20 lh-30">
                <NavLink to={`resources/article/${sys.id}`}>
                  <a>{title}</a>
                </NavLink>
              </h5>
              <p dangerouslySetInnerHTML={{ __html: description }}></p>
            </div>
          </article>
        );
      })}
    </div>
    <div className="divider-60"></div>

    {!!tableDataTotal && (
      <div>
        <nav className="navigation pagination " role="navigation">
          <div className="nav-links">
            {currentPage > 1 && (
              <a
                className="prev page-numbers"
                onClick={() => paginateTable(currentPage - 1)}
              >
                <i className="fa fa-chevron-left"></i>
                <span className="screen-reader-text">Previous page</span>
              </a>
            )}
            {paginationList.map(page => (
              <a
                key={`pagination-${page}`}
                className={classNames("page-numbers", {
                  current: currentPage === page
                })}
                onClick={() => paginateTable(page)}
              >
                <span className="meta-nav screen-reader-text">Page </span>
                {page}
              </a>
            ))}
            <a
              className="next page-numbers"
              onClick={() => paginateTable(currentPage + 1)}
            >
              <span className="screen-reader-text">Next page</span>
              <i className="fa fa-chevron-right"></i>
            </a>
          </div>
        </nav>
      </div>
    )}
  </main>
);

export default BlogItems;
